import React from 'react';

const ExportIconOutlined: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M13.8797 11.8344H13.0391C12.9734 11.8344 12.9187 11.8891 12.9187 11.9547V12.9203H3.07969V3.07969H12.9203V4.04531C12.9203 4.11094 12.975 4.16563 13.0406 4.16563H13.8813C13.9469 4.16563 14.0016 4.1125 14.0016 4.04531V2.47969C14.0016 2.21406 13.7875 2 13.5219 2H2.47969C2.21406 2 2 2.21406 2 2.47969V13.5203C2 13.7859 2.21406 14 2.47969 14H13.5203C13.7859 14 14 13.7859 14 13.5203V11.9547C14 11.8875 13.9453 11.8344 13.8797 11.8344ZM14.1703 7.90156L11.9531 6.15156C11.8703 6.08594 11.75 6.14531 11.75 6.25V7.4375H6.84375C6.775 7.4375 6.71875 7.49375 6.71875 7.5625V8.4375C6.71875 8.50625 6.775 8.5625 6.84375 8.5625H11.75V9.75C11.75 9.85469 11.8719 9.91406 11.9531 9.84844L14.1703 8.09844C14.1853 8.08674 14.1973 8.0718 14.2056 8.05475C14.214 8.03769 14.2183 8.01897 14.2183 8C14.2183 7.98103 14.214 7.96231 14.2056 7.94525C14.1973 7.92819 14.1853 7.91326 14.1703 7.90156Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ExportIconOutlined;
